import { getLocalStringDate } from "./get-local-string-date";

export const getNowDate = () => getLocalStringDate(new Date());
